/**
 * Freemium-Konfiguration für das Free-Tier-Rechnungslimit (M-UX-G4).
 *
 * SINGLE SOURCE OF TRUTH für die FE-seitige Anzeige des monatlichen
 * Free-Tier-Rechnungslimits. Ersetzt die bisher 3× kopierte lokale
 * Konstante `FREEMIUM_INVOICE_LIMIT` in `pages/InvoiceDashboard.tsx`,
 * `pages/XRechnungDashboard.tsx` und
 * `components/invoice/mobile/MobileInvoiceDashboard.tsx` (Drift-Risiko:
 * eine der 3 Kopien hätte künftig unbemerkt vom Backend-Limit abweichen
 * können — golden-rules.md "PATTERN: Shared Mapper-Funktionen ... kein
 * Copy-Paste").
 *
 * WICHTIG (Growth-Audit-Vorbehalt, ux-audit-growth.md Befund #4
 * "Monetarisierung"): Dieser Wert ist NUR die FE-Anzeige-Konstante
 * ("N von 4 Rechnungen"). Die tatsächliche Durchsetzung des Limits
 * passiert ausschließlich serverseitig im PHP-Backend (HTTP 403 bei
 * Überschreitung, s. `hooks/invoice/useInvoiceSubmission.ts#resolveErrorType`).
 * Weicht dieser Wert vom Backend-Limit ab, zeigt die UI lediglich eine
 * falsche Zahl an — sie hebelt das serverseitige Limit weder aus, noch
 * wird sie dadurch inhaltlich "wahr". Kein hartes Versprechen an den
 * Nutzer, rein deskriptiv.
 *
 * @module config/freemium
 */

/** Anzahl kostenloser Rechnungen pro Kalendermonat (Free-Tier, reiner Anzeige-Wert). */
export const FREEMIUM_INVOICE_LIMIT = 4;

/**
 * Ab diesem Zählerstand (inklusive) zeigt `InvoiceUsageMeter` den sanften
 * "Limit rückt näher"-Hinweis (Badge-Ton `caution`/`warning` statt
 * `neutral`). 3 von 4 ⇒ genau eine kostenlose Rechnung ist noch übrig.
 */
export const FREEMIUM_SOFT_WARNING_THRESHOLD = 3;
